import React, { useContext, useEffect, useMemo, useState } from 'react';
import DaumPostcode from 'react-daum-postcode';
import styled from 'styled-components';
import CustomModal from '../../components/modal/CustomModal';
import { AuthContext } from '../../navigation/AuthProvider';
import { getNumberToString } from '../../utils/util';
import UtilController from '../../controller/UtilController';
import { useToast } from '../../controller/ToastController';
import AsyncLocalStorage from '../../utils/AsyncLocalStorage';
import StoreController, {
  CurrentStoreContext,
  StoreDetailType,
  StoreImageType,
  StoreType,
} from '../../controller/StoreController';
import { useOutletContext } from 'react-router-dom';
import { SelectType } from '../../components/DropdownSelect';

const AdvertiseUpload = () => {
  const showToast = useToast();

  const [storeVideoId, setStoreVideoId] = useState<number | null>(null);
  const [storeVideoName, setStoreVideoName] = useState<string>('');
  const [storeImages, setStoreImages] = useState<StoreImageType[]>([]);
  const { currentStore } = useOutletContext<CurrentStoreContext>();

  const uploadAdvertiseVideo = async (e: any) => {
    if (storeImages.length < 5) {
      console.log('files', e.target.files);
      let origin = e.target.files[0];
      if (origin !== undefined) {
        if (origin.type !== undefined && origin.type !== null) {
          const formData = new FormData();
          formData.append('file', origin);
          const oRes = await UtilController.storeImageUploadImg(formData, currentStore.value); // 임시
          console.log('storeImageUploadImg', oRes);
          if (oRes.data) {
            const oResponse = oRes.data;
            if (oResponse.ok && oResponse.data) {
              setStoreVideoId(oResponse.data.store_media_id);
              setStoreVideoName(origin.name);
            } else {
              showToast('파일 이름이 너무 길거나 형식에 맞지 않아요', 'error');
            }
          }
          return;
        }
      }
    } else {
      showToast('더 이상 사진을 등록할 수 없어요', 'error');
    }
  };

  const uploadAdvertiseImage = async (e: any) => {
    if (storeImages.length < 5) {
      console.log('files', e.target.files);
      let origin = e.target.files[0];
      if (origin !== undefined) {
        if (origin.type !== undefined && origin.type !== null) {
          if (origin.type === 'image/png' || origin.type === 'image/jpeg') {
            const formData = new FormData();
            formData.append('file', origin);
            const oRes = await UtilController.storeImageUploadImg(formData, currentStore.value); // 임시
            console.log('storeImageUploadImg', oRes);
            if (oRes.data) {
              const oResponse = oRes.data;
              if (oResponse.ok && oResponse.data) {
                storeImages.push({
                  store_media_id: oResponse.data.store_media_id,
                  url_path: oResponse.data.url_path,
                });
                setStoreImages([...storeImages]);
              } else {
                showToast('파일 이름이 너무 길거나 형식에 맞지 않아요', 'error');
              }
            }
            return;
          }
        }
      }
    } else {
      showToast('더 이상 사진을 등록할 수 없어요', 'error');
    }
  };

  // 필수 확인
  const checkRequired = () => {
    if (storeImages.length > 0) return true;
    return false;
  };
  const deleteImage = (index: number) => {
    storeImages.splice(index, 1);
    setStoreImages([...storeImages]);
  };

  const deleteVideo = () => {
    setStoreVideoId(null);
    setStoreVideoName('');
  };

  useEffect(() => {}, [currentStore]);

  return (
    <>
      <Style>
        <div className="contentContainer">
          <div className="infoBadge">
            <h4>광고사진 등록</h4>
          </div>
          <div className="warningSign">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
            <p>광고는 랜덤으로 진행되며, 노출이 되지 않을수도 있습니다.</p>
          </div>
          <div className="inputText">
            <div className="title">
              <h4>동영상 등록</h4>
            </div>
            <div className="storeInfoWrap">
              <div className="row gap">
                <div className="videoInput">
                  {storeVideoName === '' ? '동영상을 등록해주세요' : storeVideoName}
                </div>
                <label className="imageButton edit">
                  <input
                    type="file"
                    name="video"
                    accept="video/*"
                    onChange={uploadAdvertiseVideo}
                    autoFocus={false}
                  />
                  열기
                </label>
                <button className="imageButton delete" onClick={deleteVideo}>
                  삭제
                </button>
              </div>
            </div>
          </div>
          <div className="inputText">
            <div className="title">
              <h4>사진 등록</h4>
              <h5>(최대 5장)</h5>
            </div>
            <div className="storeInfoWrap">
              <div className="imageWrap">
                <label className="photoBox" htmlFor={`storeImage`}>
                  <img src={`${process.env.PUBLIC_URL}/svg/ic_photo.svg`} alt="ic" />
                  <h5>이미지 추가</h5>
                </label>
                <input
                  id={`storeImage`}
                  type="file"
                  name="photo"
                  accept="image/*"
                  autoFocus={false}
                  onChange={uploadAdvertiseImage}
                  disabled={storeImages.length >= 5}
                />
                <div className="imageList">
                  {storeImages.map((image: any, index: number) => {
                    return (
                      <div className="previewImageWrap" key={index}>
                        <div className="imageDeleteButton">
                          <img
                            src={`${process.env.PUBLIC_URL}/svg/ic_close_white.svg`}
                            onClick={() => deleteImage(index)}
                            alt="ic"
                          />
                        </div>
                        <img className="previewImg" src={image.url_path} alt="none_image" />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <button className={`submitButton ${!checkRequired() && 'inactive'}`}>
            광고 검수 신청하기
          </button>
        </div>
      </Style>
    </>
  );
};

export default AdvertiseUpload;

const Style = styled.div`
  .contentContainer {
    border-radius: 10px;
  }

  .inputText {
    padding-bottom: 10%;
    img {
      cursor: pointer;
    }

    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 4px;

      h5 {
        color: #40977f;
        font-weight: 500;
      }
      .greyFont {
        color: #a7a7a7;
      }
      h4 {
        color: #555555;
      }
    }
    .title.initial {
      padding: 0 0 6px 0;
    }
  }

  .infoBadge {
    background: #ecf5f3;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding: 8px 20px;
    gap: 6px;
    h4 {
      color: #555555;
    }
  }

  .row.gap {
    display: flex;
    align-items: center;
    gap: 6px;
    .videoInput {
      width: 100%;
      padding: 6px 18px;
      border: 1px solid #cecece;
      border-radius: 5px;
      font-size: 14px;
      line-height: 20px;
      color: #cecece;
      text-align: left;
      background: #ffffff;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .imageButton {
      background: #ffffff;
      text-align: center;
      border-radius: 5px;
      padding: 6px 14px;
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      white-space: nowrap;
      cursor: pointer;
    }
    .imageButton.edit {
      border: 1px solid #cecece;
      color: #555555;
    }
    .imageButton.delete {
      border: 1px solid #4dd2ae;
      color: #4dd2ae;
    }
  }

  .imageList {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow-x: auto;
    padding: 12px 0;

    .row.between {
      align-items: flex-start;
    }
    .previewImageWrap {
      width: 120px;
      height: 120px;
      position: relative;
      .imageDeleteButton {
        position: absolute;
        top: 0;
        right: 0;
        width: 24px;
        height: 24px;
        border-radius: 0 5px 0 5px;
        background: rgba(0, 0, 0, 0.3);
      }
    }
    .previewImageWrap.logo {
      height: 102px;
    }

    .previewImg {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      object-fit: cover;
    }
  }
  .photoBox {
    width: 120px;
    height: 120px;
    border-radius: 5px;
    padding: 10px;
    padding-top: 20px;
    border: 1px solid #cecece;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 6px;
    cursor: pointer;

    h5 {
      color: #a7a7a7;
      font-weight: 400;
    }
  }

  input[type='file'] {
    display: none;
  }
`;
